import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { UserRoleNames } from 'src/app/core/models/users';
import { RouteGuard } from 'src/app/core/route-guards/route-guard.guard';
import { ActionLogsComponent } from '../shared/components/actionlogs-component/action-logs.component';
import { StorageDataTransferComponent } from './components/storage-data-transfer/storage-data-transfer.component';
import { StorageDetailsComponent } from './components/storage-details/storage-details.component';
import { StorageListComponent } from './components/storage-list/storage-list.component';

import { StorageMainPanelComponent } from './components/storage-main-panel/storage-main-panel.component';

const routes: Routes = [
  {
    path: 'Storages List',
    component: StorageListComponent,
    canActivate: [RouteGuard],
    data: {role: [UserRoleNames.GlobalAdmin,UserRoleNames.PowerUser,UserRoleNames.DeploymentAdmin,UserRoleNames.JobOperator]},
  },
  {
    path: 'Storages List/:cloudType/:deploymentName/:storageName',
    component: StorageMainPanelComponent,
    canActivateChild: [RouteGuard],
    data: {role: [UserRoleNames.GlobalAdmin,UserRoleNames.PowerUser,UserRoleNames.DeploymentAdmin,UserRoleNames.JobOperator]},
    children: [
      { path: 'properties', component: StorageDetailsComponent},
      { path: 'data-transfer', component: StorageDataTransferComponent },
      { path: 'logs', component: ActionLogsComponent },
      { path: '', redirectTo: 'data-transfer', pathMatch: 'full' },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { scrollPositionRestoration: 'enabled' })],
  exports: [RouterModule],
})
export class StorageRoutingModule {}
